import React from 'react';
import { Chip } from '@usepepper/sprout-kit-ui';
import { Pressable } from 'react-native';

/**
 * Props for {@link ItemDetailTabPill}.
 */
export interface ItemDetailTabPillProps {
  /** Whether this pill represents the currently selected tab. */
  isActive: boolean;
  /** Display label for the pill. */
  label: string;
  /** Called when the pill is pressed. */
  onPress: () => void;
}

/**
 * Single tab in the item-detail panel's tab bar. Uses a Sprout Kit filter
 * {@link Chip} for the selected styling, wrapped in a `Pressable` that owns the
 * `tab` / `aria-selected` semantics so the bar still reads as a tablist to
 * assistive tech (the chip's own `pressable` variant forces `role="button"`).
 *
 * @param props - {@link ItemDetailTabPillProps}.
 * @returns The rendered tab chip.
 */
export const ItemDetailTabPill: React.FC<ItemDetailTabPillProps> = ({
  isActive,
  label,
  onPress,
}) => (
  <Pressable
    accessibilityLabel={label}
    accessibilityRole="tab"
    aria-selected={isActive}
    onPress={onPress}
  >
    <Chip circular pressable selected={isActive} size="$sm">
      <Chip.Text>{label}</Chip.Text>
    </Chip>
  </Pressable>
);
